// docs: https://github.com/altostra/type-validations#readme
import { objectOf, maybe, arrayOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

const filter = objectOf({
  score: maybe(string),
  key: maybe(string),
  description: string,
});

const spamTestClientDetails = objectOf({
  score: maybe(string),
  filters: maybe(arrayOf(filter)),
  feedback: maybe(string),
  "feedback-type": maybe(string),
});

const spamTestClientData = objectOf({
  client: string,
  type: string,
  spam: number,
  details: spamTestClientDetails,
  parsed_details: string,
});

export const isEngagementGetSpamResultsIdResult = objectOf({
  feedback: arrayOf(spamTestClientData),
  pass_fail: arrayOf(spamTestClientData),
});
